import { Box, Button, Chip, Stack, Typography } from '@mui/material';

import { COLORS } from '../IndividualPlan/tokens';

export type IntegrationStatus = 'connected' | 'not_connected';

type IntegrationsCardProps = {
  status: IntegrationStatus;
  lastSyncedLabel?: string;
  onContact?: () => void;
};

const CONNECTED_PILL = { bg: '#C9EBC0', fg: '#1F4E10' };
const NOT_CONNECTED_PILL = { bg: '#F8C7C0', fg: '#7A1B0A' };

export function IntegrationsCard({ status, lastSyncedLabel, onContact }: IntegrationsCardProps) {
  const connected = status === 'connected';
  const subtitle = connected ? lastSyncedLabel : 'Contact Flashlight to learn more';
  const pill = connected ? CONNECTED_PILL : NOT_CONNECTED_PILL;

  return (
    <Box
      sx={{
        bgcolor: '#FFFFFF',
        borderRadius: 2,
        border: `1px solid ${COLORS.hairlineSoft}`,
        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)',
        p: { xs: 2.5, md: 3 },
      }}
    >
      <Typography sx={{ fontSize: 15, fontWeight: 700, color: COLORS.muted, mb: 2 }}>
        Integrations
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          aria-hidden
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: COLORS.orange,
            flexShrink: 0,
          }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.ink }}>
            Flashlight
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 13, color: COLORS.muted }}>{subtitle}</Typography>
          )}
        </Box>

        <Box sx={{ flex: 1 }} />

        <Chip
          label={connected ? 'Connected' : 'Not Connected'}
          size="small"
          sx={{
            bgcolor: pill.bg,
            color: pill.fg,
            fontWeight: 700,
            fontSize: 12,
            '& .MuiChip-label': { px: 1.5 },
          }}
        />

        {!connected && (
          <Button
            variant="outlined"
            onClick={onContact}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#D4D4DD',
              color: COLORS.ink,
              px: 2.5,
              borderRadius: 1.5,
              '&:hover': { borderColor: COLORS.ink, bgcolor: 'transparent' },
            }}
          >
            Contact
          </Button>
        )}
      </Stack>
    </Box>
  );
}
